/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputmoney
 * @description Text input that limit to numeric input with a currency format
 * @attr {Number} inputmoney-ratio The unit ratio the value is shown at.
 */
angular.module('mercury.directives.inputmoney', [])
.directive('inputmoney', ["$filter", "$parse", "$timeout", function($filter, $parse, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {
      var ratio = 1;

      //If no onUpdate is specified, default to blur
      if (!modelCtrl.$options || !modelCtrl.$options.updateOn) {
        modelCtrl.$options = {
          updateOn: 'blur'
        };
      }

      function formatModel(value) {
        if (isNaN(value)) {
          return '';
        } else {
          return $filter('currency')(parseFloat(value) * ratio);
        }
      }

      if (angular.isDefined(attrs.inputmoneyRatio)) {
        ratio = parseFloat($parse(attrs.inputmoneyRatio)(scope)) || ratio;

        scope.$watch(attrs.inputmoneyRatio, function(newRatio) {
          ratio = parseFloat(newRatio) || ratio;
          if (modelCtrl.$valid) {
            modelCtrl.$viewValue = formatModel(modelCtrl.$modelValue);
            modelCtrl.$render();
          }
        });
      }

      modelCtrl.$formatters.push(formatModel);

      modelCtrl.$validators.valid = function(modelValue) {
        return !isNaN(modelValue);
      };

      //Limit to 12 digits due to the database field limitation.
      modelCtrl.$validators.max = function(modelValue) {
        return modelValue < 999999999999;
      };
      modelCtrl.$validators.min = function(modelValue) {
        return modelValue > -999999999999;
      };

      scope.$watch(attrs.ngModel, function() {
        modelCtrl.$validate();
      });

      modelCtrl.$parsers.push(function(value) {
        var cleanValue = value.replace(/[^\d.-]/g, '');

        if (cleanValue === '' || cleanValue === '-' || cleanValue === '.') {
          cleanValue = 0;
        }

        //Remove any characters not numeric, - or . then parse as float
        return parseFloat(cleanValue) / ratio;
      });

      $(element).bind('click', function() {
        $timeout(function() {
          $(element).select();
        }, 5);
      });

      $(element).bind('blur.inputFormatter', function() {
        $timeout(function() {
          modelCtrl.$validate();
          if (modelCtrl.$valid) {
            modelCtrl.$viewValue = formatModel(modelCtrl.$modelValue);
            modelCtrl.$render();
          }
        }, 50);
      });
    }
  };
}]);
